import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from '@/components/HeroSection';
import ServicesSection from '@/components/ServicesSection';
import PricingCalculator from '@/components/PricingCalculator';
import TestimonialsSection from '@/components/TestimonialsSection';
import BlogSection from '@/components/BlogSection';
import LeadForm from '@/components/LeadForm';

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if there's a hash in the URL (e.g., /#contact) and scroll to it
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Stellars Estates - Performance-Driven Digital Marketing Solutions</title>
        <meta 
          name="description" 
          content="Transform your business with Stellars Estates' data-driven digital marketing strategies. We offer Ad Campaigns, Social Media Marketing, Website Development, and WhatsApp Marketing services." 
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Stellars Estates - Performance-Driven Digital Marketing Solutions" />
        <meta property="og:description" content="Transform your business with Stellars Estates' data-driven digital marketing strategies. We offer Ad Campaigns, Social Media Marketing, Website Development, and WhatsApp Marketing services." />
        <meta property="og:image" content="https://i.postimg.cc/3NNd39Q1/social-sharing-image-stallars-estates.jpg" />
        <meta property="og:image:secure_url" content="https://i.postimg.cc/3NNd39Q1/social-sharing-image-stallars-estates.jpg" />
        <meta property="og:image:alt" content="Stellars Estates - Digital Marketing Agency" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://i.postimg.cc/3NNd39Q1/social-sharing-image-stallars-estates.jpg" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link 
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap" 
          rel="stylesheet" 
        />
      </Helmet>

      <div className="min-h-screen w-full">
        <Header />
        <main>
          <HeroSection />
          <ServicesSection />
          <PricingCalculator />
          <TestimonialsSection />
          <BlogSection />
          <LeadForm />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default HomePage;